import { useMutation } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";

import { UserProfile } from "@coworker/types/lib/userProfileTypes";

type UserToCreate = {
  roleId: string;
  emails: string[];
  teamId: string;
  storeId: string;
  status: string;
};

async function createUser(userToCreate: UserToCreate) {
  return await httpClient.core.post<UserProfile[]>("/atkomst/createFixaUser", {
    body: userToCreate,
  });
}

export const useCreateUser = () =>
  useMutation({
    mutationFn: (userToCreate: UserToCreate) => createUser(userToCreate),
  });
